import React from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import { selectFavicon } from 'models/virtual_event';

const CustomHelmet = ({ children, ...props }: any) => {
  const favicon = useSelector(selectFavicon);
  return (
    <Helmet {...props}>
      {children}
      <link rel="shortcut icon" href={favicon} />
    </Helmet>
  );
};

export default CustomHelmet;
